import { Modal as NbModal } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Modal = NbModal;

export default addWithConfig(Modal);
